export default __webpack_public_path__ + "static/media/first-name.2dd6861f.svg";